import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useTargetingContext } from 'src/contexts/TargetingContext';
import SaveInput from './save-input';
import { usePayloadContext } from 'src/contexts/PayloadContext';
import useApi from 'src/hooks/useApi';
import services from 'src/api/service';
import { createMasterSearchPayload } from 'src/payload/master-search-filter-payload';
import { isAmazon, sortObjectKeys, isAmazonRanking } from 'src/utils/utils';
import { sweetAlertHandler } from '../../toaster';
import { useHistory } from 'react-router-dom';

export const DEFAULT_TABLE_SETTINGS = {
  CampaignName: true,
  Targeting: true,
  SearchTerm: true,
  AdvertisedASINs: true
};

export default function SaveAction({ isCustomAsinExist = false, refreshSavedFilters }) {
  
  const history = useHistory()

  const { payloadDispatch } = usePayloadContext()
  const getProfile = JSON.parse(sessionStorage.getItem('selectedProfileId'));
  const { targetingState, targetingDispatch } = useTargetingContext();
  const [saveModal, setSaveModal] = useState(false);
  const [saveText, setSaveText] = useState('');
  const isMyntra = window.location.href.indexOf('/myntra') > -1
  const isBlinkit = window.location.href.indexOf('/blinkit') > -1
  const isInstamart = window.location.href.indexOf('/instamart') > -1
  const [hideSave, setHideSave] = useState(false);
  const createMasterSearch = useApi(services.postService)
  const updateMasterSearch = useApi(services.putService)
  const getSavedSearches = useApi(services.getService)
  const isTargeting = window.location.href.indexOf('amazon/targeting') > -1
  const isAmazonMarketingStream = window.location.href.indexOf('amazon/marketing-stream') > -1
  const isZepto = window.location.href.indexOf('/zepto') > -1
  const isBigbasket = window.location.href.indexOf('/bigbasket') > -1
  const isAmazonSQP = window.location.href.indexOf('amazon/search-query-performance') > -1

  const applyAction = (isSharedForAll = false) => {
    createMasterSearch.request({
      url: '/user-default/create-master-search-filter',
      nodeAPI: 1,
      payload: {
        report: (isAmazon && isTargeting) ? 'amazon' : isMyntra ? 'myntra' : isBlinkit ? 'blinkit' : isInstamart ? 'instamart' : (isAmazon && isAmazonMarketingStream) ? 'marketing-stream' : isZepto ? 'zepto' : isBigbasket ? 'bigbasket'  : (isAmazon && isAmazonSQP) ? 'sqp' : (isAmazon && isAmazonRanking) ? 'ranking' : 'flipkart',
        name: saveText,
        json_object: targetingState.filters,
        ...(isSharedForAll ? { isSharedForAll: true } : {})
      }
    })
  };

  useEffect(() => {
    const { loading, data } = getSavedSearches
    if(!loading && data && data.success == true && data?.result && data?.result?.length > 0) {
      const lastResults = data?.result[0];
      console.log("lastResults", lastResults)
      sweetAlertHandler({ type: 'success', text: data.message ? data.message : 'Updated successfully', showConfirmButton: true, action: () => {
        setHideSave(true)
      }})

      // if(lastResults && Object.keys(lastResults).length > 0) {
      //   const updateData = lastResults && Object.keys(lastResults).length > 0 ? lastResults?.json_object?.map((item, itemIndex) => {
      //     return {
      //       ...item,
      //       filter_id: `filter_${lastResults._id}_${itemIndex}`,
      //       save_filter_id: lastResults?._id,
      //       save_filter_name: lastResults?.name
      //     }
      //   }) : []
      //   console.log("updateData", updateData)
      //   payloadDispatch({
      //     type: 'CLEAR_CROSS_FILTERS',
      //     payload: true
      //   })
      //   targetingDispatch({
      //     type: 'UPDATE_FILTERS',
      //     payload: updateData
      //   });
      //   targetingDispatch({
      //     type: 'UPDATE_APPLY_FILTERS',
      //     payload: updateData
      //   });
      // }
    }
  }, [getSavedSearches.loading])

  useEffect(() => {
    const { loading, data } = createMasterSearch
    if(!loading && data && data?.success == true) {
      setSaveModal(false)
      setSaveText("")
      refreshSavedFilters()
    } else if(!loading && data && data?.success == false) {
      sweetAlertHandler({ type: 'success', text: data.message ? data.message : 'Failed to Update !!, Please try again later', showConfirmButton: true })
    }
  }, [createMasterSearch.loading])

    // Track saved filter scenario: added new filter then removed any filter (deduct via useRef)
    const savedFilterModificationRef = useRef({
      previousCount: 0,
      hadNewFilter: false
    });
    const [predictSavedFlow, setPredictSavedFlow] = useState(false);
  
    useEffect(() => {
      const filters = targetingState?.filters || [];
      const hasSavedFilter = filters.some((f) => f?.save_filter_id);
      const currentCount = filters.length;
      const hasNewFilter = filters.some((f) => !f?.save_filter_id);
      const { previousCount, hadNewFilter } = savedFilterModificationRef.current;
  
      if (hasSavedFilter) {
        if (hasNewFilter) {
          savedFilterModificationRef.current.hadNewFilter = true;
        }
        if (currentCount < previousCount && (hadNewFilter || previousCount > 0)) {
          setPredictSavedFlow(true);
        }
        savedFilterModificationRef.current.previousCount = currentCount;
      } else {
        savedFilterModificationRef.current = { previousCount: 0, hadNewFilter: false };
        setPredictSavedFlow(false);
      }
    }, [targetingState?.filters]);

  useEffect(() => {
    const { loading, data } = updateMasterSearch
    if(!loading && data && data?.success == true) {
      setSaveModal(false)
      setSaveText("")
      setPredictSavedFlow(false)
      refreshSavedFilters()
      sweetAlertHandler({ type: 'success', text: data.message ? data.message : 'Updated successfully', showConfirmButton: true, action: () => setHideSave(true) })
    }
  }, [updateMasterSearch.loading])

  const saveToDatabase = (filters) => {
    if(filters.length == 0) return false
    updateMasterSearch.request({
      url: '/user-default/update-master-search-filter',
      nodeAPI: 1,
      payload: {
        json_object: filters,
        id: filters[0].save_filter_id,
        name: filters[0]?.save_filter_name,
      }
    })
    
  }

  useEffect(() => {
    setHideSave(false)
  }, [JSON.stringify(targetingState?.filters)])

  const isAppliedAndCurrentStateChangeDetect = JSON.stringify(targetingState?.applied_filters.map(filter => Object.assign({}, filter, { save_filter_id: undefined }))) != JSON.stringify(targetingState?.filters.map(filter => Object.assign({}, filter, { save_filter_id: undefined })))

  const [hasBgOverlay, setHasBgOverlay] = useState(false);

  // Helper functions to align key formation with report-dashboard GroupTable
  const sanitize = (str) => typeof str === 'string' ? str.replace(/[^a-zA-Z0-9]/g, '_') : '';
  // Aligning table key formation precisely with report-dashboard logic
  const getTableKeyFromFilter = (filter) => {
    console.log("getTableKeyFromFilter", filter);
    const t = filter?.tableInformation;
    if (!t) return '';

    // Matches file_context_0 logic from report-dashboard.js
    if (t.custom == 1) {
      const tableName = sanitize(t?.table_name);
      const customId = sanitize(
        t?.customDetails?.table_id // preferred, for custom tables
          ?? t?.table_id           // fallback
          ?? ''
      );
      const aggregate = sanitize(
        t?.payload?.aggregate // highly preferred source
          ?? t?.aggregate
          ?? filter?.level
          ?? ''
      );
      return `${customId}`;
    } else {
      // Non-custom: look only for payload.aggregate
      const agg = sanitize(
        t?.payload?.aggregate // match dashboard logic
          ?? t?.aggregate
          ?? filter?.level
          ?? ''
      );
      return agg;
    }
  };

  const getSourceTablesFromFilters = (filters) => {
    return filters.reduce((acc, filter) => {
      if (filter?.tableInformation?.custom == true) {
        acc[filter?.tableInformation?.tableId] = true;
        if (filter?.tableInformation?.report_source) {
          if (filter?.tableInformation?.report_source == 'search_term') {
            acc['SearchTerm'] = true;
            acc['CampaignName'] = true;
          }
          if (filter?.tableInformation?.report_source == 'campaigns') {
            acc['CampaignName'] = true;
          }
          if(filter?.tableInformation?.report_source == 'targeting') {
            acc['CampaignName'] = true;
            acc['Targeting'] = true;
          }
          if (filter?.tableInformation?.report_source == 'ad_groups') {
            acc['AdGroupName'] = true;
          }
          if (
            filter?.tableInformation?.report_source == 'asin' ||
            filter?.tableInformation?.report_source == 'advertised_asin'
          ) {
            acc['CampaignName'] = true;
            acc['AdvertisedASINs'] = true;
          }
        }
      } else {
        acc[filter?.tableInformation?.aggregate] = true;
      }
      return acc;
    }, {});
  };

  useEffect(() => {
    const observer = new MutationObserver(() => {
      setHasBgOverlay(document.querySelector('.bg-overlay') !== null);
    });
    observer.observe(document.body, { childList: true, subtree: true });
    return () => {
      observer.disconnect(); // Clean up the observer on unmount
    };
  }, []);

  const targetingTablesRef = useRef(sortObjectKeys(targetingState?.targeting_settings));

  useEffect(() => {
    if(JSON.stringify(targetingTablesRef.current) != JSON.stringify(targetingState?.targeting_settings)) {
      targetingTablesRef.current = sortObjectKeys(targetingState?.targeting_settings);
    }
  }, [targetingState?.targeting_settings]);

  useEffect(() => {
    const handleEnterKeyDown = (event) => {
      if (isAppliedAndCurrentStateChangeDetect && !hasBgOverlay) {
        if (event.key === 'Enter') {
          payloadDispatch({
            type: 'CLEAR_CROSS_FILTERS',
            payload: true
          })
          targetingDispatch({
            type: 'UPDATE_APPLY_FILTERS',
            payload: targetingState.filters
          });
          if(window.location.href.indexOf('amazon/targeting') > -1) {
            console.debug("DEBUG: Entered amazon/targeting Apply logic", targetingTablesRef.current);
            console.log("targetingState", targetingState);
            const filtersPresent = targetingState.filters?.length > 0;
            console.debug("DEBUG: filtersPresent =", filtersPresent);
            const sourceTables = getSourceTablesFromFilters(targetingState.filters);
            const defaultedSourceTables = (sourceTables && Object.keys(sourceTables).length > 0) ? sortObjectKeys({...sourceTables, ...targetingTablesRef.current}) : sortObjectKeys({...targetingTablesRef.current});
            console.debug("DEBUG: sourceTables to be dispatched:", defaultedSourceTables);
            targetingDispatch({
              type: 'UPDATE_TARGETING_SETTINGS',
              payload: defaultedSourceTables
            });
            console.debug("DEBUG: UPDATE_TARGETING_SETTINGS dispatched");
          }
        }
      }
    }
    document.addEventListener('keydown', handleEnterKeyDown)
    return () => {
      document.removeEventListener('keydown', handleEnterKeyDown)
    };
  }, [isAppliedAndCurrentStateChangeDetect, targetingState?.filters, hasBgOverlay]);

  if (targetingState?.filters?.length == 0) return null;

  return (
    <>
      {saveModal && <div className="cat-outclick" onClick={() =>  {
        setSaveModal(false)
        setSaveText("")
      }}></div>}

      {saveModal && (
        <section className={`addcat_modal z-2800 h-fitcontent bg-white top-40 wid-310 right-0`}>
          {/* HEADER */}
          <div className="header">
            Save Selected
            <span className="cursor-pointer f-18" onClick={() =>  {
                    setSaveModal(false)
                    setSaveText("")
                }}>
              &#x2715;
            </span>
          </div>
          {/* HEADER */}
          <SaveInput saveText={saveText} setSaveText={setSaveText} applyAction={applyAction} createMasterSearch={createMasterSearch} />
        </section>
      )}

      {isAppliedAndCurrentStateChangeDetect ? (
        <span className="f-12 txt-theme cursor-pointer asin_fil_clr top-13" onClick={() => {
          payloadDispatch({
            type: 'CLEAR_CROSS_FILTERS',
            payload: true
          })
          targetingDispatch({
            type: 'UPDATE_APPLY_FILTERS',
            payload: targetingState.filters
          });

          if(window.location.href.indexOf('amazon/targeting') > -1) {
            console.debug("DEBUG: Entered amazon/targeting Apply logic", targetingTablesRef.current);
            console.log("targetingState", targetingState);
            const filtersPresent = targetingState.filters?.length > 0;
            console.debug("DEBUG: filtersPresent =", filtersPresent);
            const sourceTables = getSourceTablesFromFilters(targetingState.filters);
            const defaultedSourceTables = (sourceTables && Object.keys(sourceTables).length > 0) ? sortObjectKeys({...sourceTables, ...targetingTablesRef.current}) : sortObjectKeys({...targetingTablesRef.current});
            console.debug("DEBUG: sourceTables to be dispatched:", defaultedSourceTables);
            targetingDispatch({
              type: 'UPDATE_TARGETING_SETTINGS',
              payload: defaultedSourceTables
            });
            console.debug("DEBUG: UPDATE_TARGETING_SETTINGS dispatched");
          }
          
        }}>
          Apply
        </span>
      ) : null}

      {!hideSave && !isAppliedAndCurrentStateChangeDetect && targetingState?.filters?.length && (targetingState?.filters?.some((item) => !item.filter_id || !item.save_filter_id) || predictSavedFlow ) ? (
        <span className="f-12 txt-theme cursor-pointer asin_fil_clr_two" onClick={() => {
          if(targetingState?.filters?.some((item) => item.filter_id && item.save_filter_id) == true) {
            saveToDatabase(targetingState?.filters)
          } else {
            setSaveModal(true)
          }
        }}>
          {targetingState?.filters?.some((item) => item.filter_id && item.save_filter_id) == true ? 'Update Filters' : 'Save'}
        </span>
      ) : null}
      {!isAppliedAndCurrentStateChangeDetect ? <span className="f-12 txt-theme cursor-pointer asin_fil_clr top-13" onClick={() => {
        payloadDispatch({
          type: 'CLEAR_CROSS_FILTERS',
          payload: true
        })
        targetingDispatch({
          type: 'UPDATE_FILTERS',
          payload: []
        });
        targetingDispatch({
          type: 'UPDATE_APPLY_FILTERS',
          payload: []
        });
        targetingDispatch({
          type: 'UPDATE_TARGETING_SETTINGS',
          payload: sortObjectKeys({...targetingTablesRef.current})
        });
        if(isCustomAsinExist) {
          history.push('/amazon/targeting')
        }
      }}>Clear</span> : null}
    </>
  );
}
